const graphs = {
  namespaced: true,
  state: {
    timePeriodSelected: 0,
    iceData: {
      live: [],
      settle: [],
      dates: [],
    },
    fxData: {
      live: [],
      settle: [],
      dates: [],
    },
    marketChangeSeriesData: {
      changes: [],
      times: [],
    },
  },
  getters: {
    getTimePeriodSelected(state) {
      return state.timePeriodSelected;
    },
    getIceData(state) {
      return state.iceData;
    },
    getFxData(state) {
      return state.fxData;
    },
  },
  mutations: {
    POPULATE_MARKET_CHANGE_SERIES_DATA: (state, payload) => {
      payload.forEach((dataSet, index) => {
        state.marketChangeSeriesData.times.splice(index, index + 1, dataSet[0]);
        state.marketChangeSeriesData.changes.splice(index, index + 1, dataSet[1]);
      });
    },
    SELECT_GRAPHS_TIME_PERIOD: (state, payload) => {
      state.timePeriodSelected = payload;
    },
    POPULATE_ICE_SETTLEMENT: (state, payload) => {
      state.iceData.settle = [];

      /* If time period selected is within today, then append today's settlement price only */
      if (payload.query.period == "3H" || payload.query.period == "24H" || payload.query.period == "1D") {
        const settlement = payload.res.data.data.find(
          (data) => new Date(data[0]).toDateString() == new Date().toDateString()
        );

        if (settlement) {
          for (let i = 0; i < state.iceData.dates.length; i++) {
            state.iceData.settle.splice(i, i + 1, settlement[1]);
          }
        }
      } else {
        state.iceData.dates = [];

        payload.res.data.data.forEach((data, index) => {
          state.iceData.dates.splice(index, index + 1, data[0]);
          state.iceData.settle.splice(index, index + 1, data[1]);
        });
      }
    },
    POPULATE_FX_SETTLEMENT: (state, payload) => {
      state.fxData.settle = [];

      /* Check time period selected, then decide how to populate settlement array */
      if (payload.period == "3D" || payload.period == "7D") {
        state.fxData.dates = [];

        payload.res.data.data.forEach((data, index) => {
          state.fxData.dates.splice(index, index + 1, data[0]);
          state.fxData.settle.splice(index, index + 1, data[1]);
        });
      } else {
        state.fxData.live.forEach((data, index) => {
          state.fxData.settle.splice(index, index + 1, payload.res.data.price);
        });
      }
    },
  },
  actions: {
    populateMarketChangeSeriesData: async ({ commit, rootState }) => {
      const response = await rootState.axios.get("/api/getMarketChangeSeries");

      if (response.data.success) {
        commit("POPULATE_MARKET_CHANGE_SERIES_DATA", response.data.results);
      }
    },
    selectGraphsTimePeriod: ({ commit }, payload) => {
      commit("SELECT_GRAPHS_TIME_PERIOD", payload);
    },
  },
};

export default graphs